import { find, propEq } from 'ramda'

export const findById = (id, list = []) => find(propEq('id', id), list)
